// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-datepicker-content-container {
  background-color: white !important;
  color: black !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3f51b5 !important;
  color: white !important;
}

::ng-deep .mat-calendar-body-disabled {
  color: rgba(0, 0, 0, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/generic-datetimepicker/generic-datetimepicker.component.scss"],"names":[],"mappings":"AAIA;EACE,kCAAA;EACA,uBAAA;EACA,wCAAA;AAHF;;AAMA;EACI,oCAAA;EACA,uBAAA;AAHJ;;AAME;EACE,oCAAA;AAHJ","sourcesContent":["\r\n// @import '@angular-material-components/datetime-picker/theming';\r\n// @include ngx-mat-datetime-picker-theme($theme);\r\n\r\n::ng-deep .mat-datepicker-content-container {\r\n  background-color: white !important;\r\n  color: black !important;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n::ng-deep .mat-calendar-body-selected {\r\n    background-color: #3f51b5 !important;\r\n    color: white !important;\r\n  }\r\n  \r\n  ::ng-deep .mat-calendar-body-disabled {\r\n    color: rgba(0, 0, 0, 0.3) !important;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
